module.exports = __webpack_public_path__ + "static/media/Vedanshi Shah.8c382853.jpg";